import React from 'react';
import { Nav, ProgressBar } from 'react-bootstrap';
import { withTooltip } from './app-utils';
export var Progress = function (_a) {
    var now = _a.now, description = _a.description, hidden = _a.hidden, className = _a.className;
    var tooltipStyles = hidden ? { width: '48px', height: '10px' } : { height: '10px' };
    return (React.createElement(Nav.Item, { className: 'd-flex mb-2' },
        React.createElement("div", { className: 'd-flex flex-column m-auto w-90' },
            hidden ? null : React.createElement("p", { className: 'text-white' }, description),
            React.createElement("div", { className: 'd-flex' },
                withTooltip(React.createElement(ProgressBar, { now: now, className: className + " " + (hidden ? 'm-auto' : 'w-100'), style: tooltipStyles }), 'tooltip', '123'),
                hidden ? null : React.createElement("span", { className: 'ml-2 text-muted' }, now)))));
};
//# sourceMappingURL=app-progress.js.map